import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-lfsa-boton-editar-grid',
  templateUrl: './lfsa-boton-editar-grid.component.html',
  styleUrls: ['./lfsa-boton-editar-grid.component.css']
})
export class LfsaBotonEditarGridComponent implements  ICellRendererAngularComp {

  params;
  label: string;
  colorBoton: string;
  textoAyuda: string;
  // iconEdit: string = 'fal fa-edit';
  // iconDelete: string = 'fal fa-trash-alt';

  iconEdit: string = 'fa fa-edit';
  iconDelete: string = 'fa fa-trash';
  iconImprimir: string = 'fa fa-print';
  iconVer: string = 'fa fa-eye';
  iconSelect: string = 'fas fa-clipboard-check';
  iconGraphi: string = 'fas fa-chart-pie';
  iconAdd: string = "fa fa-plus";
  iconCancel: string = 'fa fa-ban';
  iconProcesar: string = 'fa fa-play';
  disabled: boolean = false;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    this.colorBoton = this.params.colorBoton || 'btn btn-primary btn-block';
    this.textoAyuda = this.params.textoAyuda || null;
    this.setDisabled();
  }

  refresh(params?: any): boolean {
    this.params = params;
    this.setDisabled();
    return true;
  }

  setDisabled(): void {
    const raw = this.params?.disabled;
    this.disabled = typeof raw === 'function'
      ? raw(this.params?.node?.data)
      : !!raw;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      };
      this.params.onClick(params);

    }
  }

}
